// Shared constants for Plan Builder stages
export var COLOR_CYCLE = ['', 'plaintiff', 'defendant', 'exchange'];
export var DAY_COLORS = {
  plaintiff: { label: 'Plaintiff', gradient: 'linear-gradient(135deg, #3B82F6, #5A4E9E)', text: '#3B82F6' },
  defendant: { label: 'Defendant', gradient: 'linear-gradient(135deg, #EC4899, #F472B6)', text: '#EC4899' },
  exchange: { label: 'Exchange', gradient: 'linear-gradient(135deg, #F97316, #FBBF24)', text: '#F97316' },
};
export var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export var EXCHANGE_TIME_PRESETS = ['6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM'];
